import { environment } from 'src/environments/environment';
import { Constants } from '@utils/constants';
import { Injectable } from '@angular/core';

export class TransitionUserWSO2 {
  ADVISOR_GESTOR_CAN_ACCEPT_TERM: boolean;
  ASSESSOR_CLIENT_SELECTED: string;
  CLIENT: boolean;
  HBA: number;
  HBA_CURRENT_USER: string;
  HBA_EMAIL: string;
  SYSTEM_USERNAME: string;
  HBA_ASSESSOR_ID: string;
  HBA_ID: number;
  HBA_USER_ID: number;
  HBA_USERNAME: string;
  HB_BROKER: string;
  HB_BROKER_SELECT: string;
  HB_LOGIN_TYPE: string;
  HB_LOGIN_TYPE_ENABLED: string;
  TKNAPI: string;
  TKNEXP: string;
  TKNWF: string;
  TKNWF_GRAPHIC: string;
  TKNAPIREFRESH: string;
  TKN_NEGOT: string;
  USER_LOGIN_TYPE: string;
  LAYOUT_THEME_DARK: string;
  IS_ASSESSOR: boolean;
  CLIENT_PROFILE_NAME: string;
}

export class TransitionUserAdapter {
  token_type: string;
  expires_in: number;
  token: string;
  refresh_token: string;
  ws_token: string;
  second_auth: boolean;
  account: string[];
  login: string;
  user_identifier: string;
  error: boolean;
}

@Injectable({ providedIn: 'root' })
export class TransitionService {

  public transitionUserWso2: TransitionUserWSO2 = new TransitionUserWSO2();
  public transitionUserAdapter: TransitionUserAdapter = new TransitionUserAdapter();

  constructor(
  ) {
    this.transitionUserWso2.HB_LOGIN_TYPE_ENABLED = window.sessionStorage.getItem(Constants.COOKIE_HB_LOGIN_TYPE_ENABLED);
    this.transitionUserWso2.LAYOUT_THEME_DARK = Constants.LAYOUT_TYPE.Light;
  }

  setCommonObj(commonObj) {
    this.transitionUserWso2 = commonObj;
    this.save();
  }

  setKeyValue(key: string, value: any) {
    if (key) {
      this.transitionUserWso2[key] = value;
      this.save();
    }
  }

  removeKeyValue(key: string) {
    this.transitionUserWso2[key] = null;
    this.save();
  }

  get() {
    if (
      environment.LOGIN_TYPE === Constants.LOGIN_TYPE.LoginW ||
      environment.LOGIN_TYPE === Constants.LOGIN_TYPE.LoginIAM
    ) {
      return this.transitionUserWso2 = JSON.parse(window.sessionStorage.getItem(Constants.COOKIE_STORAGE_AUTH));
    } else if (environment.LOGIN_TYPE === Constants.LOGIN_TYPE.LoginA) {
      return this.transitionUserAdapter = JSON.parse(window.sessionStorage.getItem(Constants.COOKIE_STORAGE_AUTH_ADAPTER));
    }
    return;
  }

  recover() {
    if (window.sessionStorage.getItem(Constants.COOKIE_STORAGE_AUTH)) {
      this.transitionUserWso2 = JSON.parse(window.sessionStorage.getItem(Constants.COOKIE_STORAGE_AUTH));
    }
  }

  clear() {
    if (environment.LOGIN_TYPE === Constants.LOGIN_TYPE.LoginW) {
      window.sessionStorage.removeItem(Constants.COOKIE_STORAGE_AUTH);
    } else if (environment.LOGIN_TYPE === Constants.LOGIN_TYPE.LoginA) {
      window.sessionStorage.removeItem(Constants.COOKIE_STORAGE_AUTH_ADAPTER);
    }
  }

  private save() {
    window.sessionStorage.setItem(Constants.COOKIE_STORAGE_AUTH, JSON.stringify(this.transitionUserWso2));
  }

}
